import React from 'react';
import RatingButton, { SendedRatingContainer, SendedRatingImage } from './RatingButton';
import bad from './img/bad.png';
import neutral from './img/neutral.png';
import good from './img/good.png';
import Flex from 'Components/Grid/Flex';
import { EnumSize } from 'constants/enums';
import Text from 'Components/Typography/Text';
import { FontSize } from 'theme';

export const BAD_RATING_BUTTON_TEST_ID = 'bad-rating-button';

const RATING_VALUES = {
  NEUTRAL: 3,
  GOOD: 5,
  BAD: 1,
};

enum RatingText {
  'Нормально' = 3,
  'Все отлично' = 5,
  'Плохо' = 1,
}

const getImage = (rating: number) => {
  switch (rating) {
    case RATING_VALUES.NEUTRAL:
      return neutral;
    case RATING_VALUES.GOOD:
      return good;
    case RATING_VALUES.BAD:
      return bad;
  }
};

interface IRating {
  rating: number;
  size?: EnumSize;
  isSended?: boolean;
  onClick?: (x: number) => void;
  className?: string;
}

const RatingGroup: React.FC<IRating> = ({ rating, onClick, size = EnumSize.sm, isSended, className }) => {
  const onClickHandler = (rate: number) => {
    if (onClick && rating !== rate) {
      onClick(rate);
    }
  };

  if (isSended && rating) {
    return (
      <SendedRatingContainer>
        <SendedRatingImage src={getImage(rating)} />
        <Text size={FontSize.xs}>{RatingText[rating]}</Text>
      </SendedRatingContainer>
    );
  }

  return (
    <Flex middle className={className}>
      <RatingButton
        size={size}
        image={bad}
        active={rating === RATING_VALUES.BAD}
        onClick={() => onClickHandler(RATING_VALUES.BAD)}
        data-testid={BAD_RATING_BUTTON_TEST_ID}
      />
      <RatingButton
        size={size}
        image={neutral}
        active={rating === RATING_VALUES.NEUTRAL}
        onClick={() => onClickHandler(RATING_VALUES.NEUTRAL)}
      />
      <RatingButton
        size={size}
        image={good}
        active={rating === RATING_VALUES.GOOD}
        onClick={() => onClickHandler(RATING_VALUES.GOOD)}
      />
    </Flex>
  );
};

export default RatingGroup;
